/*************************************************/
/* POPUP                                         */
/*************************************************/

export function popup() {
    const overlay = document.querySelector("#overlay");
    const popup = document.querySelector(".form-popup");
    const popupButton = document.querySelector(".product-page__link-form");
    const closeButton = document.querySelector(".form-popup-close");

    if (!popup) {
        // Popup element is not present, so we won't proceed
        return;
    }
    
    const togglePopup = () => {
        overlay.style.display = (overlay.style.display === "block") ? "none" : "block";
        popup.style.display = (popup.style.display === "flex") ? "none" : "flex";
    };

    const closeOnClick = (e) => {
        if (e.target === overlay || e.target === closeButton) {
            togglePopup();
        }
    };

    const init = () => {
        popupButton.addEventListener("click", togglePopup);
        overlay.addEventListener("click", closeOnClick);
        closeButton.addEventListener("click", closeOnClick);
    };

    init();
}
